<div [class.row]="!isRow" [class.readonly]="readonly">
  <section
    class="mb-3"
    [class.col-lg-6]="!isRow"
    [class.col-lg-7]="!labelSize"
    [class.col-lg-9]="col9"
  >
    @if (!!label) {
    <label class="label-section">
      @if (mandatory && showLabel) {
      <span class="text-danger" aria-hidden="true" tabindex="-1">*</span>
      } @if (showLabel) {
      <span [innerHtml]="label"></span>
      }
      <ng-content select="[field-label]"></ng-content>
    </label>
    }
    <ng-content></ng-content>
    <nh-messages
      [field]="field"
      [label]="label"
      [option]="option"
    ></nh-messages>
  </section>
</div>
